import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id FF783CFF-DD54-492C-A1E1-323AB6CAAFC1
 * name podium-silver
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/podium-silver.svg
 * tags
 * - Sport 
 */
export const PodiumSilverIcon = createSvgIcon(<><path d="M20,10.09L22.45,11.58L21.8,8.77L24,6.89L21.11,6.64L20,4L18.87,6.64L16,6.89L18.18,8.77L17.5,11.58L20,10.09M23,23H17V13H23V23M1,17V23H7V17H1M5,21H3V19H5V21M9,10V23H15V10H9M13,21H11V12H13V21Z" /></>, 'PodiumSilverIcon');
export default PodiumSilverIcon